const url_base = process.env.REACT_APP_API_URL || 'http://localhost:3000';
const urlSocket = url_base;

export { url_base, urlSocket };
